/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import CampaignModel from 'cio/models/campaign';
import AnalyticsService from 'cio/services/analytics';
import ActionModel from 'cio/models/action';

interface VisualWorkflowMinimapArgs {
  campaign: CampaignModel;
  action: ActionModel;
  selectedMinimapAction: string;
}

export default class VisualWorkflowMinimap extends Component<VisualWorkflowMinimapArgs> {
  @service analytics!: AnalyticsService;

  @action
  trackMinimapHover(time: number) {
    this.analytics.track('message', 'minimap_viewed', {
      action: this.args.action,
      hoverTimeInSeconds: time,
    });
  }
}
